const versions = [
    {  version: "1.0.0", decp: "decpA" },
    {  version: "1.0.1", decp: "Dashboard timer add for 45sec" },
    {  version: "1.0.2", decp: "workgroup ui change" },
    {  version: "1.0.3", decp: "red and green color in speedometer and tooltip on icons" },
    {  version: "1.0.4", decp: "work group dashboard with left side sitting arrange" },
    {  version: "1.0.5", decp: "header(only comp name) and footer(poweredby supermanager)" },
    {  version: "1.0.6", decp: "in dashboard page include machine product count" },
  ];
  
  export default versions;